import {Component, OnInit} from '@angular/core';
import {
  fadeInLeftOnEnterAnimation,
  fadeInOnEnterAnimation,
  fadeOutOnLeaveAnimation,
  fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {DomSanitizer} from '@angular/platform-browser';
import {UserService} from '../../../services/user.service';
import {DelegateModel} from '../../team/models/delegate.model';
import {NavService} from '../../../services/nav.service';
import {NapiService} from '../../../services/napi.service';

@Component({
  selector: 'app-calls-history-page',
  templateUrl: './calls-history.page.html',
  styleUrls: ['./calls-history.page.scss'],
  animations: [
    fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
    fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
    fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
    fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
  ]
})

export class CallsHistoryPage implements OnInit {
  url = null;
  delegate: DelegateModel = null;

  retries = 0;
  callsList: any = null;

  constructor(
    public sanitizer: DomSanitizer,
    public userService: UserService,
    private napiService: NapiService,
    private nav: NavService,
  ) {
  }

  ngOnInit() {
    this.napiService.get('aicoach/calls-for-user/').then((res) => {
      this.callsList = res.filter(call => call.scoringStatus === 'COMPLETED');
    });
  }

  viewRecord(id: string) {
    this.nav.navigate(['/calls/scorecard', id]);
  }
}
